/* THIAGOLAYOUT */

import React from 'react';
import { Modal, Row, Col } from 'react-bootstrap';
import Badge from 'react-bootstrap/Badge';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faExclamationTriangle,
  faExclamationCircle,
  faBuildingCircleExclamation,
  faMoneyBill,
  faMoneyBillTransfer,
  faPlus,
  faPlusCircle,
  faBell,
  faWrench,
  faPlugCircleXmark,
  faCoins,
} from "@fortawesome/free-solid-svg-icons";


export const ModalGeneralCaption = (props: any, color: any) => {
  const { t } = useTranslation();

  return (
    <Modal
      show={true}
      centered
      dialogClassName="custom-modal-Caption"
      onHide={props.close}
    >
      <Modal.Body >
        <div className="content" >
          <Row className="align-items-center" >
            <h4>{t("DASHBOARD_BRANCH.COLOR_LEGEND_TITTLE")}</h4>
            <Col sm={6} md={6} lg={6} >
              <Badge
                style={{
                  backgroundColor: props.collectionForecastColor,
                  color: props.collectionForecastColor,
                }}
                bg=""
              >
                #
              </Badge>
              <b> {t("DASHBOARD_BRANCH.COLLECTION_FORECAST")}</b>
              <br />
              <Badge
                style={{
                  backgroundColor: props.inPlanCollectionServiceColor,
                  color: props.inPlanCollectionServiceColor,
                }}
                bg=""
              >
                #
              </Badge>
              <b> {t("DASHBOARD_BRANCH.IN_PLAN_COLLECTION_SERVICE")}</b>
              <br />
              <Badge
                style={{
                  backgroundColor: props.planedCollectionServiceColor,
                  color: props.planedCollectionServiceColor,
                }}
                bg=""
              >
                #
              </Badge>
              <b> {t("DASHBOARD_BRANCH.PLANNED_COLLECTION_SERVICE_")}</b>
              <br />
            </Col>
            <Col sm={6} md={6} lg={6}>
              <Badge
                style={{
                  backgroundColor: props.scheduledCollectionServiceColor,
                  color: props.scheduledCollectionServiceColor,
                }}
                bg=""
              >
                #
              </Badge>
              <b> {t("DASHBOARD_BRANCH.SCHEDULED_COLLECTION_SERVICE_")}</b>
              <br />
              <Badge
                style={{
                  backgroundColor: props.executedCollectionServiceColor,
                  color: props.executedCollectionServiceColor,
                }}
                bg=""
              >
                #
              </Badge>
              <b> {t("DASHBOARD_BRANCH.EXECUTED_COLLECTION_SERVICE_")}</b>
              <br />
              <Badge
                style={{ backgroundColor: "#dcdcdc", color: "#dcdcdc" }}
                bg=""
              >
                #
              </Badge>
              <b> {t("DASHBOARD_BRANCH.RESTRICTED_COLLECTION_SERVICE_")}</b>
              <br />
            </Col>
          </Row>
          <Row className="mt-4" >
            <h4>{t("DASHBOARD_BRANCH.SYMBOL_LEGEND_TITTLE")}</h4>
            <Col sm={6} md={6} lg={6} >
              <FontAwesomeIcon
                  style={{ color: "red" }}
                  icon={faWrench}
                  />
              <b> {t("DASHBOARD_BRANCH.UNDER_MAINTENANCE")}</b>
              <br />
              <FontAwesomeIcon
                  style={{ color: "red" }}
                  icon={faExclamationCircle}
                  />
              <b> {t("DASHBOARD_BRANCH.NOT_UPDATE_ONLINE_BALANCE")}</b>
              <br />
              <FontAwesomeIcon
                  style={{ color: "red" }}
                  icon={faPlugCircleXmark}
                  />
              <b> {t("DASHBOARD_BRANCH.OFFLINE")}</b>
              <br />
              <FontAwesomeIcon
                  style={{ color: "red" }}
                  icon={faExclamationTriangle}
                  />
              <b> {t("DASHBOARD_BRANCH.IMPOSED_PREVIEW")}</b>
              <br />
            </Col>
            <Col sm={6} md={6} lg={6}>
              <FontAwesomeIcon
                  icon={faBell}
                  />
              <b> {t("DASHBOARD_BRANCH.MULTICLIENT")}</b>
              <br />
              <FontAwesomeIcon
                  icon={faMoneyBill}
                  />
              <b> {t("DASHBOARD_BRANCH.MONETARY_VALUE")}</b>
              <br />
              <FontAwesomeIcon
                  icon={faCoins}
                  />
              <b> {t("DASHBOARD_BRANCH.PHYSICAL_VALUE")}</b>
              <br />
              <FontAwesomeIcon
                  style={{ color: "#FFC107" }}
                  icon={faExclamationTriangle}
                  />
              <b> {t("DASHBOARD_BRANCH.IMPOSED_PREVIEW_CHANGE")}</b>
              <br />              
            </Col>
          </Row>
        </div>
      </Modal.Body>
    </Modal>
  );
};